var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 28h-21C1.57 28 0 26.43 0 24.5v-21C0 1.57 1.57 0 3.5 0h21C26.43 0 28 1.57 28 3.5v21c0 1.93-1.57 3.5-3.5 3.5zM3.5 1.167A2.336 2.336 0 0 0 1.167 3.5v21A2.336 2.336 0 0 0 3.5 26.833h21a2.336 2.336 0 0 0 2.333-2.333v-21A2.336 2.336 0 0 0 24.5 1.167h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 8h27v1H1zM6 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-2.667a.667.667 0 1 0 .001 1.335A.667.667 0 0 0 6 3.333zM11 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-2.667a.667.667 0 1 0 .001 1.335A.667.667 0 0 0 11 3.333zM16.5 6c-.827 0-1.5-.897-1.5-2s.673-2 1.5-2 1.5.897 1.5 2-.673 2-1.5 2zm0-2.667c-.276 0-.5.3-.5.667 0 .368.224.667.5.667s.5-.3.5-.667c0-.368-.224-.667-.5-.667zM22 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-2.667a.667.667 0 1 0 .001 1.335A.667.667 0 0 0 22 3.333zM25 24H3V13h22v11zM4.158 22.872h19.684v-8.744H4.158v8.744zM3 10h1v2H3zM24 10h1v2h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10h21v1H4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorno);
export default __webpack_public_path__ + "static/media/horno.502f1ded268bcfe1c3cf61917ae4509b.svg";
export { ForwardRef as ReactComponent };